import { Link } from "react-router-dom";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import { Reveal } from "@/components/site/Motion";
import { SITE } from "@/config/site";

export const FinalCta = () => (
  <section data-testid="final-cta-section" className="relative mx-auto max-w-7xl px-5 sm:px-8 pb-28">
    <div className="grid grid-cols-1 lg:grid-cols-12 overflow-hidden rounded-[2.5rem] border border-white/10 bg-[#16161A]">
      <Reveal className="lg:col-span-7 min-w-0 px-6 py-14 sm:px-14 sm:py-20 flex flex-col justify-center">
        <p className="eyebrow">{SITE.address}</p>
        <h2 className="mt-5 font-display uppercase text-[7.5vw] sm:text-5xl lg:text-5xl xl:text-[3.6rem] leading-[0.88] tracking-[-0.045em]">
          Hai fame?<br /><span className="text-[#FF5500]">Ti aspettiamo.</span>
        </h2>
        <p className="mt-6 max-w-md text-zinc-300">{SITE.hours[0]}. Passa al banco o prenota: ti teniamo il pollo caldo.</p>
        <div className="mt-10 flex flex-wrap gap-3">
          <a href={SITE.whatsappHref} target="_blank" rel="noreferrer" data-testid="final-cta-whatsapp" className="btn-primary group">
            <MessageCircle className="w-5 h-5" /> Scrivici su WhatsApp
          </a>
          <Link to="/contatti" data-testid="final-cta-contatti" className="btn-ghost group">
            Contatti <ArrowUpRight className="w-4 h-4 transition-transform group-hover:rotate-45" />
          </Link>
        </div>
      </Reveal>
      <div className="lg:col-span-5 relative h-[420px] lg:h-auto lg:min-h-[560px] overflow-hidden group">
        <img src="/images/insegna.jpg" alt="Insegna Mister Pollo illuminata di notte" className="absolute inset-0 w-full h-full object-cover object-[center_35%] transition-transform duration-1000 ease-out group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t lg:bg-gradient-to-r from-[#16161A]/70 via-transparent to-transparent" />
      </div>
    </div>
  </section>
);
